import { apiAxios } from "../apiConfig";

export const getAllNews = async () => {
  try {
    const response = await apiAxios.get("/news");
    return response.data;
  } catch (error) {
    console.error("Error fetching news:", error);
    throw error;
  }
};
